import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  num: '1',
  title: 'Descarga y Completa',
  desc: 'Descarga el Perfil Trino y completa tus coordenadas básicas en 5 minutos.'
}, {
  num: '2',
  title: 'Cruza tus Datos',
  desc: 'Cruza tus datos usando el Mecanismo de la Triple Hélice.'
}, {
  num: '3',
  title: 'Aplica y Transforma',
  desc: 'Aplica la acción inmediata que tu diseño te exige para recuperar tu poder.'
}];
export function HowItWorks() {
  return <section className="py-24 bg-trino-burgundy text-white relative overflow-hidden" data-id="element-75">
      <div className="absolute inset-0 opacity-10" style={{
      backgroundImage: 'radial-gradient(#ffe471 1px, transparent 1px)',
      backgroundSize: '30px 30px'
    }} data-id="element-76"></div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-77">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-78">
          <h2 className="text-3xl sm:text-4xl font-bold font-serif mb-4" data-id="element-79">
            ¿Cómo funciona?
          </h2>
          <div className="w-24 h-1 bg-trino-gold mx-auto rounded-full" data-id="element-80"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative" data-id="element-81">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-10 left-[15%] right-[15%] h-0.5 bg-trino-gold/30" data-id="element-82"></div>

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2,
          duration: 0.6
        }} className="relative text-center" data-id="element-83">
              <div className="w-20 h-20 mx-auto bg-trino-burgundy border-4 border-trino-gold rounded-full flex items-center justify-center text-2xl font-bold font-serif text-trino-gold mb-6 relative z-10 shadow-[0_0_20px_rgba(212,168,83,0.3)]" data-id="element-84">
                {step.num}
              </div>
              <h3 className="text-xl font-bold mb-3 text-trino-cream" data-id="element-85">
                {step.title}
              </h3>
              <p className="text-trino-peach/80 leading-relaxed font-light" data-id="element-86">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}